import { root } from './stop';

export const stop = {
  ...root,
};
